export default __webpack_public_path__ + "static/media/trilha-1.b331ce23.png";